/**
 * @param {number|string} n
 * @returns {string}
 */
export function padTicketNumber(n) {
    return String(Number(n)).padStart(4, '0');
}

/**
 * @param {Array<number|string>} numbers
 * @returns {string}
 */
export function ticketsHtml(numbers) {
    return numbers.map((n) => `<span class="wtoy-drawn-ticket">${padTicketNumber(n)}</span>`).join('');
}

/**
 * @param {unknown} numbers
 * @returns {boolean}
 */
export function hasDrawnNumbers(numbers) {
    return Array.isArray(numbers) && numbers.length > 0;
}
